import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {RouteService} from '../../shared/services/route.service';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {RouteGroup} from '../../shared/models/routeGroup.model';
import {Vehicle} from '../../shared/models/vehicle.model';
import {DispatchCreate} from '../../shared/models/dispatch.model';
import {DispatchGroup} from '../../shared/models/dispatchGroup.model';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'form-dispatch-month',
    templateUrl: 'form-dispatch-month.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormDispatchMonthComponent implements OnInit, OnDestroy {
    constructor(
        private routeService: RouteService,
        private dataStorageService: DataStorageService) {
    }

    @Input() month: string;

    dispatchForm: FormGroup;
    routeGroups: RouteGroup[];
    dispatchGroups: DispatchGroup[];
    vehicles: Vehicle[];

    routeGroupOptions: any = [];
    vehicleOptions: any = [];

    selectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['label']
    };

    routeGroupSelectValue = '';
    vehicleSelectValue = '';

    is_valid = false;

    private unsubscribe$: Subject<void> = new Subject<void>();

    ngOnInit() {
        this.dispatchGroups = this.routeService.getDispatchGroup();
        this.initDispatchGroupOptions(this.dispatchGroups);

        this.initForm();

        this.routeService.dispatchGroupsChanged
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (dispatchGroups: DispatchGroup[]) => {
                    this.initDispatchGroupOptions(dispatchGroups);
                }
            );

        this.vehicles = this.routeService.getVehicles();
        this.initVehicleOptions(this.vehicles);
        this.routeService.vehiclesChanged
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (vehicles: Vehicle[]) => {
                    this.vehicles = vehicles;
                    this.initVehicleOptions(this.vehicles);
                }
            );
    }

    initForm() {
        this.dispatchForm = new FormGroup({
            'vehicle_id': new FormControl(),
            'dispatch_group_id': new FormControl()
        });
    }

    initDispatchGroupOptions(dispatchGroups: DispatchGroup[]) {
        for (const dispatchGroup of dispatchGroups) {
            this.routeGroupOptions.push({'label': dispatchGroup.title, 'value': dispatchGroup.id, 'code': dispatchGroup.title});
        }
    }

    initVehicleOptions(vehicles: Vehicle[]) {
        for (const vehicle of vehicles) {
            this.vehicleOptions.push({'label': vehicle.model, 'value': vehicle.id, 'code': vehicle.model});
        }
    }

    onAddRoute() {
        const value = this.dispatchForm.value;
        const newDispatch = new DispatchCreate(value.vehicle_id, value.dispatch_group_id);
        newDispatch.month = this.month;
        this.dataStorageService.createDispatchMonth(newDispatch)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(responseData => {
                if (responseData['error']) {
                    console.log('saving dispatch month error');
                } else {
                    alert('dispatch month added. ');
                    location.reload();
                }
            });
    }

    checkIsValid() {
        // validators required not working for ng selectize
        const value = this.dispatchForm.value;
        if (value.vehicle_id && value.dispatch_group_id) {
            this.is_valid = true;
        } else {
            this.is_valid = false;
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
